// Mock data for EAET AI Agents Website

export const mockIndustries = [
  {
    id: 'autonomousvehicles',
    name: 'Autonomous Vehicles',
    tagline: 'AI-Powered Navigation & Decision Making',
    description: 'Artificial intelligence (AI) learning and deploying software that plays a pivotal role in the development and operation of autonomous vehicles (AVs), enabling them to perceive their surroundings, make decisions, and navigate safely without human intervention.',
    image: 'https://datahacker.rs/wp-content/uploads/2019/08/Featured-Image-002-Top-5-autonomous-driving-systems-in-the-world.jpg',
    features: ['Computer Vision & Perception', 'Real-time Decision Making', 'Safe Navigation Systems', 'Continuous Learning'],
    useCases: ['Object detection & recognition', 'Path planning & navigation', 'Collision avoidance', 'Adaptive learning from driving scenarios']
  },
  {
    id: 'aibattery',
    name: 'AI Battery Management',
    tagline: 'Optimize Performance, Safety & Longevity',
    description: 'AI-driven battery management systems (BMS) monitor, protect, and optimize EV battery packs through real-time analytics and predictive maintenance. AI enhances precision in battery monitoring, optimizes energy usage, and ensures safety, longevity, and efficiency by analyzing voltage, temperature, and current fluctuations.',
    image: 'https://images.unsplash.com/photo-1593941707874-ef25b8b4a92b',
    features: ['State of Charge (SoC) & State of Health (SoH) Prediction', 'Predictive Maintenance & Anomaly Detection', 'Adaptive Charging Optimization', 'Real-time Fault Detection'],
    useCases: ['Battery aging mitigation', 'Thermal runaway prevention', 'Optimal charging strategies', 'Cell-level health monitoring']
  },
  {
    id: 'logistics',
    name: 'Logistics',
    tagline: 'Automate 80% of tracking queries',
    description: 'AI agents for shipment tracking, route optimization, and supply chain management.',
    image: 'https://images.unsplash.com/photo-1644079446600-219068676743',
    features: ['Shipment Tracking', 'Route Optimization', 'Inventory Management', 'Vendor Communication'],
    useCases: ['Order tracking', 'Delivery updates', 'Warehouse inquiries', 'Supply coordination']
  },
  {
    id: 'retail',
    name: 'Retail',
    tagline: 'Increase conversions by 45%',
    description: 'AI shopping assistants that understand products, handle orders, and personalize recommendations.',
    image: 'https://images.unsplash.com/photo-1761333477936-56fbc7851c65',
    features: ['Product Recommendations', 'Order Management', 'Returns Processing', '24/7 Support'],
    useCases: ['Product search', 'Order tracking', 'Size recommendations', 'Return requests']
  },
  {
    id: 'manufacturing',
    name: 'Manufacturing',
    tagline: 'Reduce downtime by 50%',
    description: 'AI agents for production monitoring, maintenance scheduling, and quality control.',
    image: 'https://images.unsplash.com/photo-1647427060118-4911c9821b82',
    features: ['Production Monitoring', 'Predictive Maintenance', 'Quality Assurance', 'Supply Chain'],
    useCases: ['Equipment monitoring', 'Maintenance alerts', 'Quality reports', 'Inventory tracking']
  }
];

export const mockPricingPlans = [
  {
    name: 'Startup',
    price: '$499',
    period: '/month',
    description: 'Perfect for growing businesses',
    features: [
      'Up to 1,000 conversations/month',
      'Single industry specialization',
      'Email support',
      'Basic analytics dashboard',
      'Cloud deployment',
      'API access'
    ],
    cta: 'Start Free Trial'
  },
  {
    name: 'SME',
    price: '$1,999',
    period: '/month',
    description: 'For scaling operations',
    features: [
      'Up to 10,000 conversations/month',
      'Multi-industry support',
      'Priority support',
      'Advanced analytics & insights',
      'Cloud or on-premise deployment',
      'Custom integrations',
      'Dedicated account manager'
    ],
    cta: 'Book Demo',
    popular: true
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    period: '',
    description: 'For large-scale deployments',
    features: [
      'Unlimited conversations',
      'All industries included',
      '24/7 dedicated support',
      'White-label solution',
      'On-premise deployment',
      'Custom AI training',
      'SLA guarantees',
      'Security audits'
    ],
    cta: 'Contact Sales'
  }
];

export const mockTeamMembers = [
  {
    name: 'Mark Lander',
    role: 'CEO & Co-Founder',
    bio: 'Former AI research lead at Google. PhD in Machine Learning from Stanford.',
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f'
  },
  {
    name: 'Katia Levit',
    role: 'CTO & Co-Founder',
    bio: '15+ years building enterprise software. Ex-Amazon ML architect.',
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c'
  },
  {
    name: 'Elif Lander',
    role: 'Head of AI Research',
    bio: 'Published 50+ papers on NLP. Former research scientist at OpenAI.',
    image: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d'
  },
  {
    name: 'Tom Levit',
    role: 'Chief Engineer',
    bio: 'Led engineering teams at scale. Expert in distributed systems and AI infrastructure.',
    image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7'
  }
];

export const mockBlogPosts = [
  {
    id: 1,
    title: 'The Future of AI in Customer Support',
    excerpt: 'How AI chat support agents are transforming customer service across industries, reducing costs while improving satisfaction.',
    date: '2025-01-15',
    readTime: '5 min read',
    category: 'AI Insights'
  },
  {
    id: 2,
    title: 'ROI Calculator: AI Support Agents',
    excerpt: 'Calculate the potential cost savings and efficiency gains from implementing AI chat support agents in your business.',
    date: '2025-01-05',
    readTime: '4 min read',
    category: 'Business'
  },
  {
    id: 3,
    title: 'AI Chat Agents vs Traditional Chatbots: Key Differences',
    excerpt: 'Explore the technological advances that make modern AI chat support agents far superior to traditional rule-based chatbots.',
    date: '2024-12-28',
    readTime: '6 min read',
    category: 'Technology'
  },
  {
    id: 4,
    title: 'Scaling Customer Support: From 100 to 10,000 Conversations',
    excerpt: 'Real-world deployment strategies for scaling AI chat support agents without compromising quality or response times.',
    date: '2024-12-10',
    readTime: '5 min read',
    category: 'Operations'
  },
  {
    id: 5,
    title: 'Multilingual AI Support: Breaking Language Barriers',
    excerpt: 'How modern AI chat agents provide seamless support in 100+ languages, enabling global customer service.',
    date: '2024-12-05',
    readTime: '4 min read',
    category: 'Global Business'
  },
  {
    id: 6,
    title: 'Education Sector Adoption: AI Tutors and Administrative Assistants',
    excerpt: 'Universities and schools are deploying AI chat agents to support students with enrollment, coursework, and campus life.',
    date: '2024-11-28',
    readTime: '7 min read',
    category: 'Education'
  },
  {
    id: 7,
    title: 'Retail Revolution: Personalized Shopping with AI',
    excerpt: 'How e-commerce companies use AI chat agents to increase conversion rates through personalized product recommendations.',
    date: '2024-11-20',
    readTime: '5 min read',
    category: 'Retail'
  },
  {
    id: 8,
    title: 'Integration Guide: Connecting AI Agents to Your CRM',
    excerpt: 'Step-by-step technical guide for integrating AI chat support agents with Salesforce, HubSpot, and custom CRM systems.',
    date: '2024-11-15',
    readTime: '9 min read',
    category: 'Technical Guide'
  },
  {
    id: 9,
    title: 'Manufacturing Excellence: AI for Production Support',
    excerpt: 'Predictive maintenance alerts and real-time production monitoring through AI chat interfaces in manufacturing.',
    date: '2024-11-10',
    readTime: '6 min read',
    category: 'Manufacturing'
  },
  {
    id: 10,
    title: 'The Future of Workflow Automation with AI',
    excerpt: 'Discover how AI platforms enable multi-agent orchestration to automate complex business workflows with minimal configuration.',
    date: '2025-01-20',
    readTime: '8 min read',
    category: 'Platform'
  },
  {
    id: 11,
    title: 'No-Code AI: Building Custom Agents Without Programming',
    excerpt: 'Learn how business teams can create and deploy custom AI agents using our visual workflow builder and drag-and-drop interface.',
    date: '2025-01-18',
    readTime: '6 min read',
    category: 'No-Code'
  },
  {
    id: 12,
    title: 'Human-in-the-Loop: Balancing Automation with Oversight',
    excerpt: 'Best practices for implementing approval workflows and review queues that keep humans in control of critical decisions.',
    date: '2025-01-12',
    readTime: '7 min read',
    category: 'Best Practices'
  },
  {
    id: 13,
    title: 'From Data Entry to Decision Making: AI Agent Evolution',
    excerpt: 'Track the journey of AI agents from simple automation tools to intelligent decision-making systems that continuously learn.',
    date: '2024-12-30',
    readTime: '9 min read',
    category: 'AI Evolution'
  },
  {
    id: 14,
    title: 'Analytics & Intelligence: Turning Data into Action',
    excerpt: 'How AI analytics agents can process millions of data points to deliver real-time business insights and predictive forecasting.',
    date: '2024-12-25',
    readTime: '8 min read',
    category: 'Analytics'
  },
  {
    id: 15,
    title: 'Marketing Automation 2.0: AI-Powered Growth Strategies',
    excerpt: 'Modern marketing teams leverage AI agents for content creation, lead generation, and campaign optimization at scale.',
    date: '2024-12-18',
    readTime: '7 min read',
    category: 'Marketing'
  },
  {
    id: 16,
    title: 'SOC 2 Compliance: Enterprise Security in AI Platforms',
    excerpt: 'Understanding how enterprise-grade security, encryption, and audit logs protect your data in AI automation platforms.',
    date: '2024-12-12',
    readTime: '10 min read',
    category: 'Security'
  },
  {
    id: 17,
    title: 'The 1,500+ Integration Ecosystem: Connect Anything',
    excerpt: 'Explore how modern AI platforms integrate with CRM, ERP, communication tools, and custom APIs for seamless automation.',
    date: '2024-12-08',
    readTime: '6 min read',
    category: 'Integrations'
  },
  {
    id: 18,
    title: 'Continuous Learning: AI Agents That Improve Over Time',
    excerpt: 'Deep dive into performance monitoring, A/B testing, and automated retraining that makes AI agents smarter with every interaction.',
    date: '2024-12-03',
    readTime: '8 min read',
    category: 'Machine Learning'
  },
  {
    id: 19,
    title: 'Real-Time Processing at Scale: Sub-Second Latency Explained',
    excerpt: 'Technical insights into how distributed architecture and auto-scaling deliver 99.9% uptime with minimal latency.',
    date: '2024-11-25',
    readTime: '9 min read',
    category: 'Infrastructure'
  },
  {
    id: 20,
    title: 'HR Automation: Transforming Recruitment with AI',
    excerpt: 'How AI agents streamline candidate screening, interview scheduling, and onboarding to save HR teams 20+ hours per week.',
    date: '2024-11-18',
    readTime: '7 min read',
    category: 'HR & Recruitment'
  }
];

export const mockStats = [
  { value: '70%', label: 'Reduction in Response Time' },
  { value: '45%', label: 'Increase in Customer Satisfaction' },
  { value: '24/7', label: 'Always Available Support' },
  { value: '98%', label: 'Accuracy Rate' }
];

export const mockDemoRequests = [];
export const mockContactMessages = [];